import React, { useState } from "react";
import Select from "react-select";

import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Table
} from "reactstrap";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";


import axios from "axios";
import {
  SMS_LOG_EXCEL
} from "../../constants.js";

import * as FileSaver from "file-saver";
import LoadingScreen from "react-loading-screen";
import * as XLSX from "xlsx";
import logo from "../../assets/img/logo.png";

let months = [
  {value:"January", label: "January" },
  {value:"February", label: "February" },
  {value:"March", label: "March" },
  {value:"April", label: "April" },
  {value:"May", label: "May" },
  {value:"June", label: "June" },
  {value:"July", label: "July" },
  {value:"August", label: "August" },
  {value:"September", label: "September" },
  {value:"October", label: "October" },
  {value:"November", label: "November" },
  {value:"December", label: "December" },
];
let years = [
  {value:"2020", label: "2020" },
  {value:"2021", label: "2021" },
  {value:"2022", label: "2022" },
  {value:"2023", label: "2023" },
  {value:"2024", label: "2024" },
  {value:"2025", label: "2025" },
  {value:"2026", label: "2026" },
 
];

const localJson = localStorage.getItem("user");
const user = JSON.parse(localJson)

const WhtspFallBackReport = (props) => {
 
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorhandle, setErrorHandle] = useState()
  const [logreports, setLogreports] = useState([])

  const [search, setSearch] = useState({
    month: "",
    year: "",
  });
  const [validate, setValidate] = useState({
    message: "",
    notValid: false,
  });
  const notificationAlertRef = React.useRef(null);


  const submitHandler=async()=>{
    const isValid = validatedate();
    setErrorHandle(isValid);
  
    if (Object.keys(isValid).length === 0) {
      setIsLoading(true);
  
      const lclstrg = localStorage.getItem("user");
      const user = JSON.parse(lclstrg);
  
      const payload = {
        channel: "sms",
        month: search?.month?.value+search?.year?.value,
        senderid: user?.systemid,
      };
      

     await axios.post(SMS_LOG_EXCEL, payload).then(res=>{
      const downloadlinks=res?.data?.downloadlink?.split(",")
      setLogreports({"month":res?.data?.month,"downloadlink":downloadlinks})
      console.log("resps ==>",{"month":res?.data?.month,downloadlink:downloadlinks});

     // setLogreports(res?.data)
     }).catch(e=>{
      console.log("error ==>",e);
      });
     
      setIsLoading(false);
  }
  }
const generateEXCELMonthly = async () => {
  const isValid = validatedate();
  setErrorHandle(isValid);

  if (Object.keys(isValid).length === 0) {
    setIsLoading(true);

    const lclstrg = localStorage.getItem("user");
    const user = JSON.parse(lclstrg);

    const payload = {
      year: search?.year?.value,
      month: search?.month?.value,
      uname: user?.username,
    };

    try {
      const response = await axios.post(SMS_LOG_EXCEL, payload, {
        responseType: "blob", // 👈 KEY LINE to handle Excel files
      });

      const file = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      FileSaver.saveAs(file, `${search?.year?.value}_${search?.month?.value}_Report.xlsx`); // 👈 Name your file

      setIsLoading(false);
    } catch (err) {
      let options = {};
       options = {
        place: "tr",
        message: err?.message,
        type: "warning",
        autoDismiss: 3,
      };
      notificationAlertRef?.current?.notificationAlert(options);
      setIsLoading(false);
      console.error("error====>", err.message);
    }
  }
};



 
  // const generateEXCELMonthly = async () => {
   
  
  //   const isValid  = validatedate()
  //   setErrorHandle(isValid)
  //   if (Object.keys(isValid).length==0) {
      
  //     setIsLoading(true)
  //    let lclstrg = localStorage.getItem("user");
  //    let user = JSON.parse(lclstrg);
  //    let payload={
  //     year:search?.year?.value,
  //     month:search?.month?.value,
  //     uname:user?.username

  //    }
      
  //       await axios
  //       .post(
  //         WHATSAPP_LOG_EXCEL ,payload
         
  //       )
  //         .then((res) => {
  //          setIsLoading(false)
          
  //           const body =res.data;
  //        console.log(":::  ",res.data);
  //             const fileType =
  //               "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  
  //             const fileExtension = ".xlsx";
  //             const ws = XLSX.utils.json_to_sheet(body);
  //             const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  //             const excelBuffer = XLSX.write(wb, {
  //               bookType: "xlsx",
  //               type: "array",
  //             });
  //             const data = new Blob([excelBuffer], { type: fileType });
  //             FileSaver.saveAs(data, "" + fileExtension);
          
  //         })
  //         .catch((err) =>{
  //          let options = {};
  //          options = {
  //            place: "tr",
  //            message: err?.message,
  //            type: "warning",
  //            autoDismiss: 3,
  //          };
  //          notificationAlertRef?.current?.notificationAlert(options);
  //          setIsLoading(false);
  //          console.log("error====>", err.message)
  //        })
  //       }
  //   };
  const validatedate = () => {
    let errors = {}
    let currentyr = new Date().getFullYear(); 

    if(search?.year==""){
      errors.year = "Please Select Year"
    }
     else if(Number(search?.year?.value)>currentyr){
      errors.year = "Please Select Valid Year"
    }
    if(search?.month==""){
      errors.month = "Please Select Month"
    }


    return errors;
  }


  return (
    <>
      <div className="content pb-0">
        <Row>
          <Col md="12">
            <Card className="mb-2">
              <CardBody>
                <Row>
               
          

                  <Col md="3" sm="12">
                    <p className="category">Select Year<suf style={{ color: "red" }}>*</suf> </p>
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="year"
                      value={search.year}
                      onChange={(value) => setSearch({...search,year:value})}
                      options={years}
                      placeholder="Select"
                    />
                    {errorhandle?.year && <span style={{ color: "red" }}>{errorhandle?.year}</span>}
                  </Col>
                  
                  <Col md="3" sm="12">
                    <p className="category">Select Month<suf style={{ color: "red" }}>*</suf> </p>
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="month"
                      value={search.month}
                      onChange={(value) => setSearch({...search,month:value})}
                      options={months}
                      placeholder="Select"
                    />
                    {errorhandle?.month && <span style={{ color: "red" }}>{errorhandle?.month}</span>}
                  </Col>

                

                  <Col md="2" sm="12">
                  <Button
                      color="primary "
                      className="mt-4 btn btn-icon animation-on-hover"
                      id="tooltipsubmit"
                      type="button"
                      onClick={() => submitHandler()}
                    >
                      <i className="tim-icons icon-double-right" />
                    </Button>

                     {/* <Button
                      className="btn-primary btn-simple btn-icon btn-round  btn-icon mt-4 pull-right"
                      color="primary"
                      data-placement="top"
                      id="tooltipexcel"
                      type="button"
                      onClick={() => generateEXCELMonthly()}
                    >
                      <i className="tim-icons icon-cloud-download-93" />
                    </Button>  */}
                   
                  </Col>
                </Row>
         
               
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-2 ">
              <CardBody>
                <LoadingScreen
                  children=""
                  loading={isLoading}
                  bgColor="rgba(0,0,0,0.7)"
                  spinnerColor="#9ee5f8"
                  textColor="#676767"
                  logoSrc={logo}
                  text="Loading..."
                ></LoadingScreen>
                <TableContainer component={Paper} className="tableheight">
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                    responsive
                    striped
                  >
                    <thead>
                      <tr>
                        <th>S no </th>
                        <th>Month </th>
                        <th> View</th>
                      </tr>
                    </thead>
                    <tbody>
                      {logreports?.downloadlink?.length>0?logreports?.downloadlink?.map((item,index)=>
                        
                          <tr
                          
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <td>{++index}</td>
                            <td>{logreports?.month}</td>
                            <td><a href={item} target="_blank">Click here</a></td>
                          </tr>
                        
                      ) : (
                        <tr>
                          <td colSpan={5}>No Records Found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </TableContainer>
              </CardBody>
            </Card>
          </Col>
        </Row>
       {
        isLoading&&<Row>
        <Col className="mb-0" md="12">
          <Card className="mb-0">
            
              <LoadingScreen
                children=""
                loading={isLoading}
                bgColor="rgba(0,0,0,0.7)"
                spinnerColor="#9ee5f8"
                textColor="#676767"
                logoSrc={logo}
               
              ></LoadingScreen>
         
           
         

          </Card>
        </Col>
      </Row>
       } 
      </div>
    </>
  );
};

export default WhtspFallBackReport;
